import { XCloseGray } from "../icons/XClose"
import { Column } from "./Column"
import { Row } from "./Row"
import { TextComponent } from "./TextComponent"

export const Toast = ({ title, message, className, handleClose, handleAction  }: { title: string, message: string | JSX.Element, className?: string, handleClose?: () => void, handleAction?: () => void | undefined }) => {

    return (
        <Row
            crossAxisAlignment="center"
            mainAxisAlignment="center"
            className={`fixed z-50 bg-black px-8 py-6 md:rounded-lg text-white backdrop-blur-l top-0 md:top-10 left-1/2 -translate-x-1/2 w-full md:w-fit gap-3 ${className} ${handleAction && "cursor-pointer"}`}
            {...handleAction && { onClick: handleAction }}
        >
            <img
                className="object-contain w-12 -mt-1"
                src="/unjabbed-logo.png"
                alt="unjabbed logo"
                draggable={false}
                width={240}
                height={240}
            />
            <Column>
                <TextComponent variant="h5" className="font-semibold">
                    {title}
                </TextComponent>
                <TextComponent variant="h5" className="max-w-80 overflow-hidden text-ellipsis whitespace-nowrap">{message}</TextComponent>
            </Column>
            {handleClose &&
                <button 
                    onClick={(event: React.MouseEvent) => { handleClose(); event.stopPropagation(); }}
                    className="h-8 w-8 hover:bg-neutral-800 items-center justify-center flex rounded-full"
                    aria-label="handleClose toast notification"
                >
                    <XCloseGray />
                </button>
            }
        </Row>
    )
}